// 多页面入口配置
module.exports = {
  index: {
    // // 首页
    // entry: 'src/entries/index.js',
    // template: 'public/index.html',
    // filename: 'index.html'
    entry: 'src/entries/login.js',
    template: 'public/index.html',
    filename: 'index.html'
  },
  // productDetail: {
  //   // 产品详情页
  //   entry: 'src/entries/productDetail.js',
  //   template: 'public/video.html',
  //   filename: 'product-detail.html'
  // },
  // policyDetail: {
  //   // 保单详情页
  //   entry: 'src/entries/policyDetail.js',
  //   template: 'public/index.html',
  //   filename: 'policy-detail.html'
  // },
  // hotList: {
  //   // 榜单列表
  //   entry: 'src/entries/hotList.js',
  //   template: 'public/index.html',
  //   filename: 'hot-list.html'
  // },
  // newsDetail: {
  //   // 消息详情
  //   entry: 'src/entries/newsDetail.js',
  //   template: 'public/index.html',
  //   filename: 'news-detail.html'
  // },
  // applicationDetail: {
  //   // 保单详情页
  //   entry: 'src/entries/applicationDetail.js',
  //   template: 'public/index.html',
  //   filename: 'application-detail.html'
  // },
  paymentServiceList: {
    // 缴费服务列表页
    entry: 'src/entries/paymentService/list.js',
    template: 'public/index.html',
    filename: 'payment-service-list.html'
  },
  PaymentServiceList: {
    // 缴费服务列表页
    entry: 'src/entries/paymentService/list.js',
    template: 'public/index.html',
    filename: 'payment-service-list.html'
  },
  PaymentServiceDetail: {
    // 缴费服务详情页
    entry: 'src/entries/paymentService/detail.js',
    template: 'public/index.html',
    filename: 'payment-service-detail.html'
  },
  PaymentServiceAttention: {
    // 缴费服务注意事项页
    entry: 'src/entries/paymentService/attention.js',
    template: 'public/index.html',
    filename: 'payment-service-attention.html'
  },
  // myCard: {
  //   // 我的卡片页
  //   entry: 'src/entries/myCard.js',
  //   template: 'public/index.html',
  //   filename: 'my-card.html'
  // },
  // myCardDetail: {
  //   // 我的卡片详情页
  //   entry: 'src/entries/myCardDetail.js',
  //   template: 'public/mycarddetail.html',
  //   filename: 'my-card-detail.html'
  // },
  // aboutSC: {
  //   // 关于简易复效页
  //   entry: 'src/entries/aboutSC.js',
  //   template: 'public/index.html',
  //   filename: 'about-SC.html'
  // },
  staticPage: {
    // 静态文本页
    entry: 'src/entries/staticPage.js',
    template: 'public/index.html',
    filename: 'static-page.html'
  },
  editContact: {
    // 更改联系方式页
    entry: 'src/entries/editContact.js',
    template: 'public/index.html',
    filename: 'edit-contact.html'
  },
  redirectBack: {
    // 信用卡关闭页
    entry: 'src/entries/redirectBack.js',
    template: 'public/index.html',
    filename: 'redirect-back.html'
  },
  // consultantServicesDetail: {
  //   // 顾问服务详情页
  //   entry: 'src/entries/consultantServicesDetail.js',
  //   template: 'public/index.html',
  //   filename: 'consultant-service-detail.html'
  // },
  // submitHistoryList: {
  //   // 提交历史列表页
  //   entry: 'src/entries/submitHistoryList.js',
  //   template: 'public/index.html',
  //   filename: 'submit-history-list.html'
  // },
  // submitHistoryDetail: {
  //   // 提交历史详情页
  //   entry: 'src/entries/submitHistoryDetail.js',
  //   template: 'public/index.html',
  //   filename: 'submit-history-detail.html'
  // },
  // // 缴费服务-缴费注意事项
  // costNotify: {
  //   entry: 'src/entries/policyCost/costNotify.js',
  //   template: 'public/index.html',
  //   filename: 'cost-notify.html'
  // },
  // // 缴费服务-缴交首期保费 保单更改保费和非定期缴费详情页
  // costCalculator: {
  //   entry: 'src/entries/policyCost/costCalculator.js',
  //   template: 'public/index.html',
  //   filename: 'cost-calculator.html'
  // },
  // // 取消申请结果页
  // cancelResult: {
  //   entry: 'src/entries/cancelResult.js',
  //   template: 'public/index.html',
  //   filename: 'cancel-result.html'
  // },
  // // 跳转应用市场页
  // marketPage: {
  //   entry: 'src/entries/marketPage.js',
  //   template: 'public/index.html',
  //   filename: 'market-page.html'
  // },
  // // 我的文件列表
  // myFile: {
  //   entry: 'src/entries/myFile.js',
  //   template: 'public/index.html',
  //   filename: 'my-file-list.html'
  // },
  // // EB/MPF文件列表
  // myTypeFile: {
  //   entry: 'src/entries/myTypeFile.js',
  //   template: 'public/index.html',
  //   filename: 'my-type-file-list.html'
  // },
  // // 电子理赔申请
  // claimApplication: {
  //   entry: 'src/entries/claimApplication.js',
  //   template: 'public/index.html',
  //   filename: 'claim-application.html'
  // },
  // // 提交记录历史
  // claimHistory: {
  //   entry: 'src/entries/claimHistory.js',
  //   template: 'public/index.html',
  //   filename: 'claim-history.html'
  // },
  // // 我的提交记录列表页
  // fileSubmitRecord: {
  //   entry: 'src/entries/submitFileRecord.js',
  //   template: 'public/index.html',
  //   filename: 'submit-file-record.html'
  // },
  mailingAddressList: {
    // 更改通讯地址
    entry: 'src/entries/mailingAddress.js',
    template: 'public/index.html',
    filename: 'mailing-address.html'
  },
  changeContact: {
    // 保单更改服务-更改联系方式
    entry: 'src/entries/policyChangeService/changeContact.js',
    template: 'public/index.html',
    filename: 'change-contact.html'
  },
  confirmContent: {
    // 保单更改服务-更改联系方式确认内容
    entry: 'src/entries/policyChangeService/confirmContent.js',
    template: 'public/index.html',
    filename: 'confirm-content.html'
  },
  saleSetting: {
    // 促銷設置頁
    entry: 'src/entries/policyChangeService/saleSetting.js',
    template: 'public/index.html',
    filename: 'sale-setting.html'
  },
  // 提交结果页
  submitResult: {
    entry: 'src/entries/submitResult.js',
    template: 'public/index.html',
    filename: 'submit-result.html'
  },
  changeAutopayDetail: {
    // 更改自动转账日期详情页
    entry: 'src/entries/changeAutopayDate/detail.js',
    template: 'public/index.html',
    filename: 'change-autopay-detail.html'
  },
  // example: {
  //   entry: 'src/entries/example.js',
  //   template: 'public/index.html',
  //   filename: 'example.html'
  // },
  // withdrawCash: {
  //   // 保单更改服务——即磅详情页
  //   entry: 'src/entries/policyChangeService/withdrawCash.js',
  //   template: 'public/index.html',
  //   filename: 'withdraw-cash.html'
  // },
  // withdrawAttention: {
  //   // 保单更改服务——即磅注意事项
  //   entry: 'src/entries/policyChangeService/withdrawAttention.js',
  //   template: 'public/index.html',
  //   filename: 'withdraw-attention.html'
  // },
  // skipResumePayment: {
  //   entry: 'src/entries/policyChangeService/skipResumePayment.js',
  //   template: 'public/index.html',
  //   filename: 'skip-resume-payment.html'
  // },
  // changePaymentInfo: {
  //   entry: 'src/entries/policyChangeService/changePaymentInfo.js',
  //   template: 'public/index.html',
  //   filename: 'change-payment-info.html'
  // },
  // consultantCard: {
  //   // 顾问卡片
  //   entry: 'src/entries/consultantCard.js',
  //   template: 'public/index.html',
  //   filename: 'consultant-card.html'
  // },
  // videoTest: {
  //   // 播放器页
  //   entry: 'src/entries/videoTest.js',
  //   template: 'public/video.html',
  //   filename: 'video-test.html'
  // },
  // submitFile: {
  //   // 提交文件页
  //   entry: 'src/entries/submitFile.js',
  //   template: 'public/index.html',
  //   filename: 'submit-file.html'
  // },
  // updateProfile: {
  //   // 更改资料页
  //   entry: 'src/entries/updateProfile.js',
  //   template: 'public/index.html',
  //   filename: 'update-profile.html'
  // },
  // submitRecordListMPF: {
  //   // 更改记录列表页--MPF
  //   entry: 'src/entries/submitRecordListMPF.js',
  //   template: 'public/index.html',
  //   filename: 'submit-record-list.html'
  // },
  // submitDetailMPF: {
  //   // 更改记录详情页--MPF
  //   entry: 'src/entries/submitDetailMPF.js',
  //   template: 'public/index.html',
  //   filename: 'submit-record-detail.html'
  // },
  // survivalProof: {
  //   // 保单更改服务-在生證明
  //   entry: 'src/entries/survivalProof.js',
  //   template: 'public/index.html',
  //   filename: 'survival-proof.html'
  // },
  // changeOwnership: {
  //   // changeOwnership
  //   entry: 'src/entries/changeOwnership.js',
  //   template: 'public/index.html',
  //   filename: 'change-ownership.html'
  // },
  // submitHistoryInputDetail: {
  //   entry: 'src/entries/submitHistoryInputDetail.js',
  //   template: 'public/index.html',
  //   filename: 'submit-history-input-detail.html'
  // },
  eBankInAccountSetup: {
    // 設立電子入帳户口
    entry: 'src/entries/eBankInAccountSetup.js',
    template: 'public/index.html',
    filename: 'e-bank-in-account-setup.html'
  },
  login: {
    entry: 'src/entries/login.js',
    template: 'public/index.html',
    filename: 'login.html'
  },
  dashboard: {
    entry: 'src/entries/dashboard.js',
    template: 'public/index.html',
    filename: 'dashboard.html'
  },
  termsAndConditions: {
    entry: 'src/entries/termsAndConditions.js',
    template: 'public/index.html',
    filename: 'terms-and-conditions.html'
  }//,
  // policyList: {
  //   entry: 'src/entries/policyList.js',
  //   template: 'public/index.html',
  //   filename: 'policy-list.html'
  // }
}
